// extracted by mini-css-extract-plugin
module.exports = {"container":"_2va9u9yIsWvJepH_bHgNx-"};